// extracted by mini-css-extract-plugin
module.exports = {"pg-use-box":"dq","pgUseBox":"dq","use-card-wrap":"dr","useCardWrap":"dr","use-box-wrap":"ds","useBoxWrap":"ds"};